import omit from 'lodash/omit';
import isString from 'lodash/isString';
import {useEffect,useState} from 'react';

import CheckIcon from '@mui/icons-material/Check';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CustomTextField from '../common/CustomTextField';
import useDebouncedState from '../../hooks/useDebouncedState';
import {
  useGetPatientNotesQuery, 
  useCreatePatientNoteMutation,
  useUpdatePatientNoteMutation
} from '../../redux/services/patientNoteApi';


const handleCreate = ({patientId, post, setCreatedOnce}) => async () => {
  if (!patientId) return;
  setCreatedOnce(true);
  await post({patient_id: patientId, text: ''});
};

const handleUpdate = ({id, put}) => async text => {
  console.log('handleUpdate', {id, text});
  if (!id) return;
  await put({id, body: {text}});
};

const FreeTextNote = props => {
  const {patientNote} = props;
  const [text, setText] = useState(patientNote.text);
  const [debouncedText, setDebouncedText] = useState(patientNote.text);
  useDebouncedState(text, setDebouncedText, 500);
  const [put, req] = useUpdatePatientNoteMutation();
  const onUpdate = handleUpdate({id: patientNote.id, put});
  useEffect(() => {
    if (isString(debouncedText)) onUpdate(debouncedText)
  }, [debouncedText]);
  return (
    <Stack spacing={0.25}>
      <CustomTextField
        {...omit(props, 'patientNote')}
        label='Free Text Notes'
        inputType='textarea'
        rows={5}
        multiline
        defaultValue={patientNote?.text || ''}
        onChange={e => setText(e.target.value)}
        helperText='These notes do not appear in the medical note and are only visible to providers.'
      />
      {
        // if successfully saved, show a small "Saved" text
        req.isSuccess && (
          <Stack direction='row' alignItems='center' spacing={0.5}>
            <CheckIcon 
              fontSize='small' 
              color='success'
              style={{position: 'relative', top: 4, marginRight: 4}}
            />
            <Typography variant='caption' color='success.main' style={{fontWeight: 500}}>
              Saved
            </Typography>
          </Stack>
        )
      }
    </Stack>
  );
};

const FreeTextNoteContainer = props => {
  const {patientId} = props;
  const [createdOnce, setCreatedOnce] = useState(false);
  const patientNoteQuery = useGetPatientNotesQuery(
    {patient_id: patientId}, 
    {skip: !patientId}
  );
  const [post, reqPost] = useCreatePatientNoteMutation();
  const patientNote = patientNoteQuery?.data?.data?.[0];
  const patientNoteDoesNotExist = (
    !patientNote 
    && patientId 
    && patientNoteQuery.isSuccess
  );
  const isCreating = reqPost.isLoading;
  const created = reqPost.isSuccess;
  const shouldCreate = (
    patientNoteDoesNotExist
    && !isCreating 
    && !created
    && !createdOnce
  );
  const onCreate = handleCreate({patientId, post, setCreatedOnce});
  useEffect(() => {
    if (shouldCreate) onCreate({patientId, post});
  }, [shouldCreate]);
  if (!patientNote) {
    return (
      <CustomTextField 
        disabled 
        multiline 
        inputType='textarea' 
        fullWidth
        rows={5} 
        label='Free Text Notes' 
        helperText='Loading...' 
      />
    );
  }  
  const childProps = {
    patientNote,
  };
  return <FreeTextNote {...childProps} />;
};

export default FreeTextNoteContainer;